type CurrencyType = {
    currency: string
    short: string
};

const currencies: CurrencyType[] = [
    { currency: "SEK", short: "kr" },
    { currency: "NOK", short: "kr" },
    { currency: "EUR", short: "€" },
];

export const usePricing = () => {


    return {
        allCurrencies: currencies,
    }
}